import { isoDateTimeSchema } from "@repo/types";
import { z } from "zod";

import { DRIVER_PRICE_MAX_PERCENT_THRESHOLD } from "@/utils/delivery-pricing";

import errorMessages from "../error-messages";

const MINUTE_MS = 60_000;

/** Not before the current minute. */
function disablePast(value: string) {
  return Math.floor(Date.parse(value) / MINUTE_MS) >= Math.floor(Date.now() / MINUTE_MS);
}

const publishDeliverySchema = z
  .object({
    id: z.number(),
    clientFinalPrice: z.coerce.number().min(0.01, "Client price must be greater than 0"),
    carAvailabilityDate: isoDateTimeSchema.refine(disablePast, {
      message: errorMessages.disablePast,
    }),
    carPickUpDate: isoDateTimeSchema.refine(disablePast, {
      message: errorMessages.disablePast,
    }),
    carDeliveryDeadline: isoDateTimeSchema.refine(disablePast, {
      message: errorMessages.disablePast,
    }),
    selectedDriverId: z.coerce.number().nullish(),
    wantedPrice: z.number(),
    maxPrice: z.number().min(0.01, "Maximum price must be greater than 0"),
    minPrice: z.number(),
    medianPrice: z.number().optional(),
  })
  .refine(
    (data) =>
      data.clientFinalPrice <= 0 ||
      data.maxPrice <= data.clientFinalPrice * DRIVER_PRICE_MAX_PERCENT_THRESHOLD,
    {
      message: errorMessages.driverMaxExceedsClientPercent,
      path: ["maxPrice"],
    }
  );

export type PublishDeliverySchemaType = z.infer<typeof publishDeliverySchema>;
export default publishDeliverySchema;
